// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5cdf2849","732":"beba3206","766":"354c23ea"}[chunkId] + ".chunk.js";
};